import {Model} from "ords/dist/model/model";

export class PortfolioRating extends Model {
    hasResult() {
        return !!this.results.length
    }

    getResult() {
        if (!this.hasResult()) {
            return null;
        }
        return this.results[0];
    }

    getValue() {
        if (!this.hasResult()) {
            return null;
        }

        if (this.type === 1) {
            const id = this.getResult().portfolio_rating_option_id;
            for (const option of this.options) {
                if (option.id === id) {
                    return option.value
                }
            }
        }

        if (this.type === 2) {
            return this.getResult().value;
        }

        return null;
    }
}

export const PortfolioRatingModelConfig = {
    name: 'portfolioRating',
    model: PortfolioRating,
    relations: [
        {name: 'results', model_name: 'portfolioRatingResult', returns_many: true, type: 'hasMany'}
    ]
}
